export default "__VITE_ASSET__d06a515c__"